import { render, staticRenderFns } from "./renderPostFailed.vue?vue&type=template&id=e407dac8&scoped=true"
import script from "./renderPostFailed.vue?vue&type=script&lang=js"
export * from "./renderPostFailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e407dac8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e407dac8')) {
      api.createRecord('e407dac8', component.options)
    } else {
      api.reload('e407dac8', component.options)
    }
    module.hot.accept("./renderPostFailed.vue?vue&type=template&id=e407dac8&scoped=true", function () {
      api.rerender('e407dac8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/standardTab/renderPost/renderPostFailed.vue"
export default component.exports